// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_2hm10EQXhMG0K55ho6VeCG","iconSpin":"_3nbGA0rBOOgyKsOIUcfpom","icon-spin":"_3QXN36vLwQOwCLOjYtJlx6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Spinner/styles.css
// module id = 2419
// module chunks = 0